// removed by extract-text-webpack-plugin
module.exports = {"search":"search","search__input":"search__input","active":"active","tips-open":"tips-open","svg-icon":"svg-icon","search__submit":"search__submit","search__tips":"search__tips","open":"open","search__tips-text":"search__tips-text","search-page":"search-page","search-page__count":"search-page__count","search-page__item":"search-page__item","link":"link","path":"path","descr":"descr","search-page__form":"search-page__form","input-search-page":"input-search-page","btn-search-page":"btn-search-page","search-page__tips":"search-page__tips","search-page__clear-form":"search-page__clear-form","show":"show"};


//////////////////
// WEBPACK FOOTER
// ../css/components/_search.scss
// module id = 285
// module chunks = 0